import { trpc } from "@blis/trpc/react";

import { SearchableSelect } from "@/components/ui/searchable-select";

export function SplitBillingSelect({
  value,
  onChange,
  orgId,
}: {
  value: number[];
  onChange: (value: number[]) => void;
  orgId: number;
}) {
  const { data } = trpc.orgs.byOrg.useQuery(
    { orgId, allowSplitBilling: true },
    {
      enabled: !!orgId,
    },
  );
  const options = data || [];

  const orgOptions = options.filter((opt) => opt.id !== orgId);
  const selectedKeys = new Set(value);

  return (
    <SearchableSelect
      selectionMode="multiple"
      selectedKeys={selectedKeys}
      onSelectionChange={(keys) => {
        if (keys === "all") {
          onChange(orgOptions.map((opt) => opt.id));
        } else {
          onChange(Array.from(keys) as number[]);
        }
      }}
    >
      <SearchableSelect.Button
        isDisabled={orgOptions.length === 0}
        className="justify-between"
      >
        <SearchableSelect.Value
          items={orgOptions}
          getKey={(item) => item.id}
          getText={(item) => item.name}
          placeholder="None"
          className="flex-1 text-start"
        >
          {({ selectedItems }) => (
            <span className="truncate">
              {selectedItems.length === 1
                ? selectedItems[0].name
                : `${selectedItems.length} organizations`}
            </span>
          )}
        </SearchableSelect.Value>
      </SearchableSelect.Button>
      <SearchableSelect.Popover placement="bottom end">
        <SearchableSelect.Input placeholder="Search split billing..." />
        <SearchableSelect.List shouldFocusOnHover items={orgOptions}>
          {(item) => {
            return (
              <SearchableSelect.MultiItem id={item.id} textValue={item.name}>
                {item.name}
              </SearchableSelect.MultiItem>
            );
          }}
        </SearchableSelect.List>
      </SearchableSelect.Popover>
    </SearchableSelect>
  );
}
